export const ToolbarDivider = () => {
  return <div className="h-4 w-px bg-border-primary" />
}
